module.exports = __webpack_public_path__ + "static/media/chiefAccountant-0.35a6fa13.png";